import { NavBar, List, Cell, Search, Tag, Empty } from 'react-vant'
import { ArrowLeft, FriendsO } from '@react-vant/icons'
import { useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import request from '../../api/request'

export default function TeacherClasses() {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const [finished, setFinished] = useState(false)
    const [list, setList] = useState([])
    const [searchValue, setSearchValue] = useState('')
    const [page, setPage] = useState(1)

    const onLoad = async () => {
        setLoading(true)
        try {
            // 使用专属的 /my 接口获取老师关联的班级
            const res = await request.get('/academic/classes/my/', {
                params: {
                    page: page,
                    page_size: 20,
                    search: searchValue
                }
            })

            const newList = res.items || []
            setList(prev => page === 1 ? newList : [...prev, ...newList])

            setPage(prev => prev + 1)
            if (newList.length < 20 || list.length + newList.length >= res.total) {
                setFinished(true)
            }
        } catch (error) {
            console.error('获取班级失败:', error)
            setFinished(true)
        } finally {
            setLoading(false)
        }
    }

    const onSearch = (val) => {
        setSearchValue(val)
        setPage(1)
        setList([])
        setFinished(false)
        // search will trigger through useEffect or initial load
    }

    useEffect(() => {
        setPage(1)
        setList([])
        setFinished(false)
    }, [searchValue])

    return (
        <div className="page-container" style={{ background: '#f8fafc', minHeight: '100vh' }}>
            <NavBar
                title="学生管理"
                leftArrow={<ArrowLeft />}
                onClickLeft={() => navigate(-1)}
                fixed
                placeholder
            />

            <Search
                value={searchValue}
                onChange={setSearchValue}
                placeholder="搜索班级名称"
                background="#fff"
            />

            <div style={{ marginTop: 12 }}>
                <List
                    loading={loading}
                    finished={finished}
                    onLoad={onLoad}
                    finishedText="没有更多了"
                >
                    {list.length > 0 ? list.map(item => (
                        <Cell
                            key={item.id}
                            title={item.class_name}
                            label={`${item.grade} | 学生: ${item.current_student_count}人`}
                            isLink
                            icon={<FriendsO style={{ marginRight: 8, color: '#0891b2' }} />}
                            onClick={() => navigate(`/teacher/students?classId=${item.id}&className=${item.class_name}`)}
                            value={<Tag style={{ color: '#0891b2', borderColor: 'rgba(13, 148, 136, 0.3)', background: 'rgba(13, 148, 136, 0.05)' }}>{item.academic_year}</Tag>}
                        />
                    )) : (
                        !loading && <Empty description="暂无关联班级" />
                    )}
                </List>
            </div>
        </div>
    )
}
